/* eslint-disable react/prop-types */
import React, { Suspense } from "react";
import { DataDisplay, Loading } from "../data-display/data-display";
import {
  DashboardOutput,
  DashboardTekort,
  DashboardScenarioArbeidsongeschiktheid,
  KlantnaamReadOnly
} from "../../../.generated/forms/formstypes";
import { Tekort } from "../../components/tekort/tekort";
import { uitgangspuntenSchema, tekortSchema } from "../../infra/dashboard-schema";
import { klantnaamSchema } from "../../../shared/generic-parts/klantnaam/schema";
import { LoadingSpinner } from "adviesbox-shared";

interface ArbeidsongeschiktheidResultaatProps {
  onClick: () => void;
  situatie: string;
}

const getAanvrager = (data: DashboardOutput, partner = false): KlantnaamReadOnly => {
  const dash = data.dashboards?.[Object.keys(data.dashboards)[0]];
  return (partner ? (dash?.aanvrager2 as any) : (dash?.aanvrager1 as any)) ?? klantnaamSchema.default();
};

const getArbeidsongeschiktheid = (data: DashboardOutput): DashboardScenarioArbeidsongeschiktheid | null => {
  const dash = data.dashboards?.[Object.keys(data.dashboards)[0]];
  return dash?.arbeidsongeschiktheid ?? null;
};

const getTekort = (data: DashboardOutput): DashboardTekort => {
  return getArbeidsongeschiktheid(data)?.tekort ?? tekortSchema.default();
};

export const ArbeidsongeschiktheidResultaat: React.FC<ArbeidsongeschiktheidResultaatProps> = ({
  onClick,
  situatie
}) => {
  return (
    <Suspense fallback={<Loading />}>
      <button
        type="button"
        className="new-dashboard__entry-btn"
        data-testid="button-testid"
        onClick={onClick}
      >
        <h2 className="mb-2">ARBEIDSONGESCHIKTHEID</h2>
        <DataDisplay
          endpoint="Arbeidsongeschiktheid?berekenTekort=true"
          autostart={false}
          isVoorstel={situatie === "voorstel"}
          loader={() => <LoadingSpinner size="S" />}
          render={(data: DashboardOutput) => {
            if (data?.dashboards?.[Object.keys(data.dashboards)[0]].arbeidsongeschiktheid === null) return <></>;
            if (data?.dashboards?.[Object.keys(data.dashboards)[0]].arbeidsongeschiktheid !== null) {
              return (
                <div>
                  <Tekort
                    header="Arbeidsongeschiktheid"
                    tekort={getTekort(data)}
                    uitgangspunten={getArbeidsongeschiktheid(data)?.uitgangspunten ?? uitgangspuntenSchema.default()}
                    aanvrager={getAanvrager(data) as any}
                    partner={getAanvrager(data, true) as any}
                  />
                </div>
              );
            }
          }}
        />
      </button>
    </Suspense>
  );
};
